module.exports = __webpack_public_path__ + "img/FacebookIcon.42b6080.svg";